export default "__VITE_ASSET__DPjHRol9__"